import React, { useState } from "react";
import CustomDialog from "../../../components/modals/CustomDialog/CustomDialog";
import { Controller, useForm } from "react-hook-form";
import { Button } from "../../../components/forms/Buttons/Button";
import Select from "../../../components/forms/Select/Select";
import {
  getClassrooms,
  exportClassroomPassesPDF,
} from "../../../services/olympiad/classroomService";
import { DocumentArrowDownIcon } from "@heroicons/react/24/solid";

export default function ExportClassroom({
  modalOpen,
  setModalOpen,
  classrooms,
}) {
  const [loading, setLoading] = useState(false);
  const { handleSubmit, watch, control } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);

    await exportClassroomPassesPDF(data.classroom)
      .then((res) => {
        window.open(res.file, "_blank");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <CustomDialog
      isOpen={modalOpen}
      setIsOpen={setModalOpen}
      closeModal={() => {
        setModalOpen(false);
      }}
      headerText={"Комментарий"}
    >
      <form className="flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex w-full flex-col gap-4">
          {/* )} */}
          <Controller
            control={control}
            name="classroom"
            rules={{ required: true }}
            render={({ field }) => (
              <Select
                label={"Кабинет"}
                required
                className=""
                value={field.value}
                options={classrooms?.map((cls) => ({
                  label: cls.room_number,
                  value: cls.uuid,
                }))}
                // placeholder={t('announcement.select_positions')}
                onChange={(e) => {
                  // setSelectedDistrict(e);
                  field.onChange(e.value);
                }}
              />
            )}
          />
        </div>
        <div className="flex justify-end">
          <Button
            loading={loading}
            type="submit"
            Icon={DocumentArrowDownIcon}
            color="success"
            text="Загрузить"
            onClick={() => {}}
          />
        </div>
      </form>
    </CustomDialog>
  );
}
